import { createAction } from '@reduxjs/toolkit';
import { ThemeColor } from '../../../api/admin-themes/types';

export const setDemoColor = createAction<Omit<ThemeColor, 'id'>>('SET_DEMO_COLOR');

export const setDemoColors = createAction<ThemeColor[]>('SET_DEMO_COLORS');

export const setDefaultColors = createAction('SET_DEFAULT_COLORS');
